import { Card, CardContent, Stack, Typography } from '@mui/material'
import { LeadTimeStatistics as Stats } from '@src/types/leadtime'
import { useTranslation } from 'react-i18next'

interface LeadTimeStatisticsProps {
  statistics: Stats
}

const LeadTimeStatistics = ({ statistics }: LeadTimeStatisticsProps) => {
  const { t } = useTranslation()

  const cards = [
    {
      label: t('leadTime.statistics.average'),
      value: statistics.averageDays.toFixed(1),
      unit: t('leadTime.statistics.days'),
    },
    {
      label: t('leadTime.statistics.median'),
      value: statistics.medianDays.toFixed(1),
      unit: t('leadTime.statistics.days'),
    },
    {
      label: t('leadTime.statistics.min'),
      value: statistics.minDays,
      unit: t('leadTime.statistics.days'),
    },
    {
      label: t('leadTime.statistics.max'),
      value: statistics.maxDays,
      unit: t('leadTime.statistics.days'),
    },
    {
      label: t('leadTime.statistics.totalItems'),
      value: statistics.totalItems,
      unit: t('leadTime.statistics.items'),
    },
  ]

  return (
    <Stack direction="column" spacing={2} sx={{ height: '100%' }}>
      {cards.map((card, index) => (
        <Card key={index} sx={{ flex: 1 }}>
          <CardContent>
            <Typography color="textSecondary" gutterBottom variant="body2">
              {card.label}
            </Typography>
            <Typography component="div">
              {card.value} {card.unit}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Stack>
  )
}

export default LeadTimeStatistics
